import {ResaleFirstDraftCreationModalProps} from "./types";
import Modal from "../../../ui-components/Modal";
import Button from "../../../ui-components/Button";
import {FormattedMessage} from "react-intl";
import {useIntl} from "react-intl";

export const ResaleFirstDraftCreationModal = ({
  onConfirm,
  onDismiss,
} : ResaleFirstDraftCreationModalProps) => {
  const intl = useIntl();
  return <Modal onExit={onDismiss}>
    <div className="flex flex-col gap-8">
      <h1 className="text-2xl font-extrabold">
        <FormattedMessage id="approve_agent_draft" defaultMessage="Approva la versione dell'agente"/>
      </h1>
      <p>
        <FormattedMessage
          id="approve_agent_draft_message"
          defaultMessage={`Prima di creare una nuova bozza, visualizza quella finale dell'agente e approvala.`}
        />
      </p>
      <div className="w-full">
        <Button
          full
          onClick={onConfirm}
        >
          <FormattedMessage id="view_" defaultMessage={"visualizza"}/>
        </Button>
      </div>
    </div>
  </Modal>
}